export enum CategoryGroupType
{
    Automotive = 0,
    Lifestyle = 1,
}